var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "d-flex justify-content-center" }, [
    _c("div", { staticClass: "web-camera-container" }, [
      _c("div", { staticClass: "video-options" }, [
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.deviceId,
                expression: "deviceId",
              },
            ],
            staticClass: "custom-select",
            on: {
              change: function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.deviceId = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
            },
          },
          _vm._l(_vm.videoDevices, function (videoDevice, index) {
            return _c(
              "option",
              { key: index, domProps: { value: videoDevice.deviceId } },
              [_vm._v(_vm._s(videoDevice.label))]
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _vm.isCameraOpen
        ? _c(
            "div",
            { staticClass: "camera-box", class: { flash: _vm.isShotPhoto } },
            [
              _c("div", {
                staticClass: "camera-shutter",
                class: { flash: _vm.isShotPhoto },
              }),
              _vm._v(" "),
              _c("video", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isPhotoTaken,
                    expression: "!isPhotoTaken",
                  },
                ],
                ref: "camera",
                attrs: {
                  id: "camera",
                  width: "100%",
                  height: 393.75,
                  autoplay: "",
                },
              }),
              _vm._v(" "),
              _c("canvas", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isPhotoTaken,
                    expression: "isPhotoTaken",
                  },
                ],
                ref: "canvas",
                attrs: {
                  id: "photoTaken",
                  width: _vm.getwith,
                  height: _vm.getheight,
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isLoading,
              expression: "isLoading",
            },
          ],
          staticClass: "camera-loading",
        },
        [_vm._m(0)]
      ),
      _vm._v(" "),
      _vm.isCameraOpen && !_vm.isLoading
        ? _c("div", { staticClass: "camera-shoot mb-0" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "button" },
                on: { click: _vm.takePhoto },
              },
              [_vm._v("\n                Hacer una foto\n            ")]
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "loader-circle" }, [
      _c("li"),
      _vm._v(" "),
      _c("li"),
      _vm._v(" "),
      _c("li"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }